module.exports = "/_next/static/images/6708118032d55d9ea56ccaf26a543203-prepayment_limitbar.png";